import React, { useRef, useEffect, useState } from "react";
import Chart from 'react-apexcharts';
import { loadDashboardData } from "../api/apiService";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Link } from 'react-router-dom';
import { useToken } from "../components/TokenContext";
 



const CappingBar = () => {
  const [loading, setLoading] = useState(false);
  const [cappingPercent, setCappingPercent] = useState(0);
 const [dashboardData, setDashboardData] = useState(null);
  const [referralLink, setReferralLink] = useState(null);
  const { jwtToken, fetchToken } = useToken();
const [timeLeft, setTimeLeft] = useState("");
const countdownRef = useRef(null);
  const fetchDashboard = async () => {
    setLoading(true);
    try {
      const currentToken = jwtToken || (await fetchToken());
      if (!currentToken) return;
      const loginToken = localStorage.getItem("LoginToken") || currentToken;
      const data = await loadDashboardData(currentToken, loginToken);
      setCappingPercent( data.Dashboard.CAPPINGPER);
    }
    catch (err) {
      setDashboardData(null);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, [jwtToken]);

  const percent = cappingPercent; // dynamic capping value

  const options = {
    chart: {
      type: 'radialBar',
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: 0,
        endAngle: 360, // 👈 FULL CIRCLE
        hollow: {
          size: '68%',
          background: '#0f2027',
        },
        track: {
          background: '#1c2b36',
          strokeWidth: '100%',
        },
        dataLabels: {
          name: {
            show: true,
            fontSize: '13px',
            color: '#9ca3af',
            offsetY: 28,
          },
          value: {
            show: true,
            fontSize: '30px',
            fontWeight: 700,
            color: '#00f2fe',
            offsetY: -10,
            formatter: (val) => `${val}%`,
          },
        },
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'diagonal1',
        gradientToColors: ['#4facfe'],
        stops: [0, 100],
      },
    },
    stroke: {
      lineCap: 'round',
    },
    labels: ['Capping Used'],
  };

  const series = [percent];

  return (
    <div className="card">
      <div className="card-body">
        <div className="capping-apex-circle">
          <h4 className="mb-3 text-white">
            {' '}
            <span className="text-warning">3X </span> Capping Bar
          </h4>
          <Chart
            options={options}
            series={series}
            type="radialBar"
            height={260}
          />

          <div class="cap-container">
            <div class="cap-card">
              <div class="cap-icon-row">
                <div class="cap-icon">🎯</div>

                <div className='capping-right'>
                  <h3 class="cap-title">Capping Reached</h3>

                  <div class="cap-text">
                    Congratulations Your total income has reached the maximum
                    limit
                    <b>(3× your package)</b>. All earnings have been temporarily
                    paused. To resume income please perform a <b>retopup</b>.
                  </div>
                </div>
              </div>

              <div class="cap-note">
                <div>
                  <b>Deduction Details</b>
                </div>
                <ul className='pt-0 mt-0'>
                  <li>10% admin charge during withdrawal</li>
                  <li>
                    Minimum withdrawal amount is <b>$20</b>
                  </li>
                </ul>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CappingBar;
